import {useCookies} from 'react-cookie'
import {COOKIE_EXPIRATION} from 'shared/constant/COOKIE_EXPIRATION'

// NOTE: 고객사 요구사항으로 브라우저 끌 때 로그인이 풀리게 유지 ( 세션 쿠키로 변경 )
const useLoginCookie = () => {
	const cookieName = 'ALC1'
	const [cookie, setCookie, removeCookie] = useCookies([cookieName])

	const createCookie = (token) => {
		setCookie(cookieName, token, {
			path: '/',
			sameSite: 'none',
			secure: true,
			// expires: new Date(Date.now() + COOKIE_EXPIRATION.ONE_MONTH),
		})
	}

	const deleteCookie = () => {
		removeCookie(cookieName, {path: '/'})
	}

	return [cookie[cookieName], createCookie, deleteCookie]
}

export default useLoginCookie
